import React, { useState, useEffect, Fragment, useContext } from "react";
import Layout from "components/sales/layout/layout";
import { Button } from "react-bootstrap";
import ConstantInput from "components/sales/Input/constantInput/constantInput";
import localization from "assets/localization/localization";
import FileUpload from "components/sales/fileUpload/fileUpload";
import { toast } from "react-toastify";
import DropDownInput from "components/sales/Input/dropDownInput/dropDownInput";
import Images from "assets/images/imageData";
import ModalPop from "components/sales/modal/modal";
import { Link } from "react-router-dom";
import { BaseUrl } from "contexts/baseUrl/baseUrl";

const FinanceDirectorAction = ({
  payoutDetailsWithId,
  match,
  getAllThePayoutDetailsWithId = [],
  updateAllPayoutDetails,
  payoutAccountDetails,
  getPayoutAccountDetailsWithId = [],
}) => {
  const [inputList, setInputList] = useState({
    action: "",
    utr: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  const [modificationRow, setModificationRow] = useState(false);
  const [isModal, setIsModal] = useState(false);
  const { baseUrl } = useContext(BaseUrl);

  useEffect(() => {
    setIsLoading(true);
    (async () => {
      await payoutDetailsWithId(match?.params?.id);
      await payoutAccountDetails(match?.params?.id);
    })();
    setIsLoading(false);
  }, [payoutDetailsWithId, payoutAccountDetails]);

  const handleModify = () => {
    setModificationRow(true);
  };

  const handleModalHide = () => setIsModal(false);

  const handleInput2Value = (value, field) => {
    setInputList((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleChange = (e, field) => {
    setInputList((prev) => ({
      ...prev,
      [field]: e.target.value,
    }));
  };

  const handleSubmit = async () => {
    if (!inputList.action) {
      toast.error("Please select an action.");
      return;
    }

    if (inputList.action === "complete" && !inputList.utr) {
      toast.error("Please enter UTR number for completing the action.");
      return;
    }

    const inputData = [
      {
        ...inputList,
        loan_application_id: parseInt(match?.params?.id),
      },
    ];
    setIsLoading(true);
    const res = await updateAllPayoutDetails(inputData);
    if (res.status === true) {
      setIsModal(true);
    }
    setIsLoading(false);
  };

  return (
    <Layout title={"Payout Requests"} isGoback isLoading={isLoading}>
      {/* card for dealer account details */}
      <div className="panel-card">
        <div className="panel-heading">Dealer Account Details</div>
        <div className="panel-body">
          <div className="details-listing mb-5">
            <table className="table table-bordered mr-4">
              <tbody>
                <tr>
                  <th>Account Number</th>
                  <td>
                    {getPayoutAccountDetailsWithId?.DEALER?.account_number}
                  </td>
                </tr>
                <tr>
                  <th>IFSC Code</th>
                  <td>{getPayoutAccountDetailsWithId?.DEALER?.ifsc_code}</td>
                </tr>
                <tr>
                  <th>Bank Name</th>
                  <td>{getPayoutAccountDetailsWithId?.DEALER?.bank_name}</td>
                </tr>
                <tr>
                  <th>Branch Name</th>
                  <td>{getPayoutAccountDetailsWithId?.DEALER?.branch_name ?? '-'}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      {Object.keys(getAllThePayoutDetailsWithId).length > 0 ? (
        <Fragment>
          {/* card for payout details */}
          <div className="panel-card">
            <div className="panel-heading">
              Payout Request(Finance Director)
            </div>
            <div className="panel-body">
              <div className="details-listing mb-5">
                <table className="table table-bordered mr-4">
                  <tbody>
                  <tr>
                    <th>Default Payout Amount</th>
                    <td>
                      {"Rs. " +
                          getAllThePayoutDetailsWithId.final_payout_amount}
                    </td>
                  </tr>
                  <tr>
                    <th> Payout status</th>
                    <td>
                      {
                          getAllThePayoutDetailsWithId.final_status}
                    </td>
                  </tr>
                  {getAllThePayoutDetailsWithId.final_status !== 'PAYOUT_COMPLETED' &&
                      <>
                        <tr>
                          <th>
                            Action<span style={{color: "red"}}>*</span>
                          </th>
                          <td>
                            <DropDownInput
                                data={[
                                  {id: "initiate", name: "Initiate"},
                                  {id: "cancel", name: "Cancel"},
                                  {id: "complete", name: "Complete"}
                                ]}
                                label={"Action"}
                                required
                                value={inputList?.action}
                                errorMsg={localization.requiredName}
                                getIdValue={(val) =>
                                    handleInput2Value(val.id, "action")
                                }
                                isStarRequired={true}
                            />
                          </td>
                        </tr>
                        <tr>
                          <th>
                            UTR Number
                            <span style={{color: "red"}}>*</span>
                          </th>
                          <td>
                            <ConstantInput
                                errorMsg={
                                  localization.requiredCompanyName
                                }
                                type="text"
                                value={inputList?.utr}
                                handleChange={(e) =>
                                    handleInput2Value(e, "utr")
                                }
                            />
                          </td>
                        </tr>
                      </>
                  }

                  {/* Render payout details */}
                  {(() => {
                    // const defaultGeneratedItem =
                    //   getAllThePayoutDetailsWithId.track.find(
                    //     (trackItem) =>
                    //       trackItem.status == "DEFAULT_GENERATED"
                    //   );
                    // const modifiedByDSMItem =
                    //   getAllThePayoutDetailsWithId.track.find(
                    //     (trackItem) => trackItem.status == "MODIFIED_BY_DSM"
                    //   );
                    // const modifiedByCentralOpsItem =
                    //   getAllThePayoutDetailsWithId.track.find(
                    //     (trackItem) =>
                    //       trackItem.status === "MODIFIED_BY_CENTRAL_OPS"
                    //   );
                    // const modifiedByBussinessHeadItem =
                    //   getAllThePayoutDetailsWithId.track.find(
                    //     (trackItem) =>
                    //       trackItem.status === "MODIFIED_BY_BUSINESS_HEAD"
                    //   );


                    // if (
                    //     !modifiedByDSMItem &&
                    //     !modifiedByCentralOpsItem &&
                    //     !modifiedByBussinessHeadItem
                    // ) {
                    //   return (
                    //       <>
                    //         <tr>
                    //           <th>Default Payout Amount</th>
                    //           <td>
                    //             {"Rs. " +
                    //                 getAllThePayoutDetailsWithId.final_payout_amount}
                    //           </td>
                    //         </tr>
                    //         <tr>
                    //           <th>Default Payout Percentage</th>
                    //           <td>
                    //             {getAllThePayoutDetailsWithId.final_payout_percentage +
                    //                 "%"}
                    //           </td>
                    //         </tr>
                    //         <tr>
                    //           <th>Status</th>
                    //           <td>{getAllThePayoutDetailsWithId.status}</td>
                    //         </tr>
                    //       </>
                    //   );
                    // }

                    // if (
                    //     modifiedByDSMItem ||
                    //     modifiedByCentralOpsItem ||
                    //     modifiedByBussinessHeadItem ||
                    //     getAllThePayoutDetailsWithId?.final_status ==
                    //     "ACCEPTED_BY_DEALER" ||
                    //     getAllThePayoutDetailsWithId?.final_status ==
                    //     "PARTIAL_PAYMENT_RELEASED" ||
                    //     getAllThePayoutDetailsWithId?.final_status ==
                    //     "PAYOUT_INITIATED" ||
                    //     getAllThePayoutDetailsWithId?.final_status ==
                    //     "PAYOUT_COMPLETED"
                    // ) {
                    //   return (
                    //       <>
                    //         <tr>
                    //           <th>Default Payout Amount</th>
                    //           <td>
                    //             {"Rs. " + defaultGeneratedItem?.payout_amount}
                    //           </td>
                    //         </tr>
                    //         <tr>
                    //           <th>Default Payout Percentage</th>
                    //           <td>
                    //             {defaultGeneratedItem?.payout_percentage + "%"}
                    //           </td>
                    //         </tr>
                    //         <tr>
                    //           <th>Status</th>
                    //           <td>{getAllThePayoutDetailsWithId?.status}</td>
                    //         </tr>
                    //
                    //         {modifiedByDSMItem &&
                    //             (getAllThePayoutDetailsWithId?.final_status ==
                    //                 "ACCEPTED_BY_DEALER" ||
                    //                 getAllThePayoutDetailsWithId?.final_status ==
                    //                 "PARTIAL_PAYMENT_RELEASED" ||
                    //                 getAllThePayoutDetailsWithId?.final_status ==
                    //                 "PAYOUT_INITIATED" ||
                    //                 getAllThePayoutDetailsWithId?.final_status ==
                    //                 "PAYOUT_COMPLETED") && (
                    //                 <>
                    //                   <tr>
                    //                     <th>Payout Amount suggested by DSM</th>
                    //                     <td>
                    //                       {"Rs. " + modifiedByDSMItem?.payout_amount}
                    //                     </td>
                    //                   </tr>
                    //                   <tr>
                    //                     <th>Payout Percentage suggested by DSM</th>
                    //                     <td>
                    //                       {modifiedByDSMItem?.payout_percentage +
                    //                           "%"}
                    //                     </td>
                    //                   </tr>
                    //                   <tr>
                    //                     <th>DSM File</th>
                    //                     <td>
                    //                       <a
                    //                           href={
                    //                             modifiedByDSMItem?.payout_modification_proof_url
                    //                           }
                    //                           className="btn btn-primary btn-sm"
                    //                           target={"_blank"}
                    //                           rel="noopener noreferrer"
                    //                       >
                    //                         <i className="fa fa-download"></i>{" "}
                    //                         Download
                    //                       </a>
                    //                     </td>
                    //                   </tr>
                    //                 </>
                    //             )}
                    //
                    //         {modifiedByDSMItem &&
                    //             (getAllThePayoutDetailsWithId?.final_status ==
                    //                 "ACCEPTED_BY_DEALER" ||
                    //                 getAllThePayoutDetailsWithId?.final_status ==
                    //                 "PARTIAL_PAYMENT_RELEASED" ||
                    //                 getAllThePayoutDetailsWithId?.final_status ==
                    //                 "PAYOUT_INITIATED" ||
                    //                 getAllThePayoutDetailsWithId?.final_status ==
                    //                 "PAYOUT_COMPLETED") && (
                    //                 <>
                    //                   <tr>
                    //                     <th>
                    //                       Payout Amount suggested by Central Ops
                    //                     </th>
                    //                     <td>
                    //                       {"Rs. " +
                    //                           modifiedByCentralOpsItem?.payout_amount}
                    //                     </td>
                    //                   </tr>
                    //                   <tr>
                    //                     <th>
                    //                       Payout Percentage suggested by Central Ops
                    //                     </th>
                    //                     <td>
                    //                       {modifiedByCentralOpsItem?.payout_percentage +
                    //                           "%"}
                    //                     </td>
                    //                   </tr>
                    //                   <tr>
                    //                     <th>Central Ops File</th>
                    //                     <td>
                    //                       <a
                    //                           href={
                    //                             modifiedByCentralOpsItem?.payout_modification_proof_url
                    //                           }
                    //                           className="btn btn-primary btn-sm"
                    //                           target={"_blank"}
                    //                           rel="noopener noreferrer"
                    //                       >
                    //                         <i className="fa fa-download"></i>{" "}
                    //                         Download
                    //                       </a>
                    //                     </td>
                    //                   </tr>
                    //                 </>
                    //             )}
                    //         {modifiedByDSMItem &&
                    //             (getAllThePayoutDetailsWithId?.final_status ==
                    //                 "ACCEPTED_BY_DEALER" ||
                    //                 getAllThePayoutDetailsWithId?.final_status ==
                    //                 "PARTIAL_PAYMENT_RELEASED" ||
                    //                 getAllThePayoutDetailsWithId?.final_status ==
                    //                 "PAYOUT_INITIATED" ||
                    //                 getAllThePayoutDetailsWithId?.final_status ==
                    //                 "PAYOUT_COMPLETED") && (
                    //                 <>
                    //                   <tr>
                    //                     <th>
                    //                       Payout Amount suggested by Business Head
                    //                     </th>
                    //                     <td>
                    //                       {"Rs. " +
                    //                           modifiedByBussinessHeadItem?.payout_amount}
                    //                     </td>
                    //                   </tr>
                    //                   <tr>
                    //                     <th>
                    //                       Payout Percentage suggested by Business
                    //                       Head
                    //                     </th>
                    //                     <td>
                    //                       {modifiedByBussinessHeadItem?.payout_percentage +
                    //                           "%"}
                    //                     </td>
                    //                   </tr>
                    //                   <tr>
                    //                     <th>Business Head File</th>
                    //                     <td>
                    //                       <a
                    //                           href={
                    //                             modifiedByBussinessHeadItem?.payout_modification_proof_url
                    //                           }
                    //                           className="btn btn-primary btn-sm"
                    //                           target={"_blank"}
                    //                           rel="noopener noreferrer"
                    //                       >
                    //                         <i className="fa fa-download"></i>{" "}
                    //                         Download
                    //                       </a>
                    //                     </td>
                    //                   </tr>
                    //                   {getAllThePayoutDetailsWithId?.final_status ==
                    //                       "PAYOUT_COMPLETED"}
                    //                   <tr>
                    //                     <th>UTR No.</th>
                    //                     <td>{getAllThePayoutDetailsWithId?.utr}</td>
                    //                   </tr>
                    //                 </>
                    //             )}
                    //         {getAllThePayoutDetailsWithId?.final_status ==
                    //             "ACCEPTED_BY_DEALER" && (
                    //                 <tr>
                    //                   <th>
                    //                     Action<span style={{color: "red"}}>*</span>
                    //                   </th>
                    //                   <td>
                    //                     <DropDownInput
                    //                         data={[
                    //                           {id: "initiate", name: "Initiate"},
                    //                           {id: "cancel", name: "Cancel"},
                    //                           {id: "complete", name: "Complete"}
                    //                         ]}
                    //                         label={"Action"}
                    //                         required
                    //                         value={inputList?.action}
                    //                         errorMsg={localization.requiredName}
                    //                         getIdValue={(val) =>
                    //                             handleInput2Value(val.id, "action")
                    //                         }
                    //                         isStarRequired={true}
                    //                     />
                    //                   </td>
                    //                 </tr>
                    //             )}
                    //
                    //         {getAllThePayoutDetailsWithId?.final_status ==
                    //             "PARTIAL_PAYMENT_RELEASED" ||
                    //             (getAllThePayoutDetailsWithId?.final_status ==
                    //                 "PAYOUT_INITIATED" && (
                    //                     <>
                    //                       <tr>
                    //                         <th>
                    //                           Action
                    //                           <span style={{color: "red"}}>*</span>
                    //                         </th>
                    //                         <td>
                    //                           <DropDownInput
                    //                               data={[
                    //                                 {id: "complete", name: "Complete"},
                    //                               ]}
                    //                               label={"Action"}
                    //                               required
                    //                               value={inputList?.action}
                    //                               errorMsg={localization.requiredName}
                    //                               getIdValue={(val) =>
                    //                                   handleInput2Value(val.id, "action")
                    //                               }
                    //                               isStarRequired={true}
                    //                           />
                    //                         </td>
                    //                       </tr>
                    //
                    //                       <tr>
                    //                         <th>
                    //                           UTR Number
                    //                           <span style={{color: "red"}}>*</span>
                    //                         </th>
                    //                         <td>
                    //                           <ConstantInput
                    //                               errorMsg={
                    //                                 localization.requiredCompanyName
                    //                               }
                    //                               type="number"
                    //                               value={inputList?.utr}
                    //                               handleChange={(e) =>
                    //                                   handleInput2Value(e, "utr")
                    //                               }
                    //                           />
                    //                         </td>
                    //                       </tr>
                    //                     </>
                    //                 ))}
                    //       </>
                    //   );
                    // }
                    return null;
                  })()}
                  </tbody>
                </table>
                {Object.keys(getAllThePayoutDetailsWithId).length > 0 && getAllThePayoutDetailsWithId.final_status !== 'PAYOUT_COMPLETED' &&
                    <div className="d-flex mb-3">
                      <Button
                          className="btn btn-sm btn-success"
                          onClick={handleSubmit}
                      >
                        Send for Finance Release
                      </Button>
                    </div>
                }

                {/*{(getAllThePayoutDetailsWithId?.final_status ==*/}
                {/*    "PARTIAL_PAYMENT_RELEASED" ||*/}
                {/*    getAllThePayoutDetailsWithId?.final_status ==*/}
                {/*    "ACCEPTED_BY_DEALER" ||*/}
                {/*    getAllThePayoutDetailsWithId?.final_status ==*/}
                {/*    "PAYOUT_INITIATED") && (*/}
                {/*    <div className="d-flex mb-3">*/}
                {/*      <Button*/}
                {/*          className="btn btn-sm btn-success"*/}
                {/*          onClick={handleSubmit}*/}
                {/*      >*/}
                {/*        Send for Finance Release*/}
                {/*      </Button>*/}
                {/*    </div>*/}
                {/*)}*/}
              </div>
            </div>
          </div>

          <ModalPop
              title={localization.conf}
              show={isModal}
              handleModalHide={handleModalHide}
              keyboard
              backdrop
          >
            <div className="text-center">
              <div className="success">
                <img src={Images?.tick} alt=""/>
              </div>
              <h5>Updated Successfully</h5>
              <Link
                  to={`${baseUrl}/ucd/finance-director-payout-list`}
                  className="btn btn-primary mb-4"
              >
                Go to UCD List <img src={Images?.ArrowRight} alt="" />
              </Link>
            </div>
          </ModalPop>
        </Fragment>
      ) : (
        <Fragment>
          <div>
            <img src={Images?.NoData} alt="No data" width="100%" />
          </div>
        </Fragment>
      )}
    </Layout>
  );
};

export default FinanceDirectorAction;
